import _ from "lodash";
import moment from "moment";
import React from "react";
import { convertIsoToLocalDateTime, getFloatValue } from "src/constant";
import FORSlogo from "src/assets/images/FORSlogo.png";
import muzPdfLogo from "src/assets/images/pdfLogoMuz.jpg";

import New_SigmaLogo from "src/assets/images/S1GMA_Icon_128x128.png";

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

const MontserratExtraBold = require("../../../assets/fonts/Montserrat-ExtraBold.ttf");
const MontserratRegular = require("../../../assets/fonts/Montserrat-Regular.ttf");

export const chunkSubstr = (str, size) => {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }
  return chunks;
};


const newPDFComponent = ({
  getIndividualDispatchOrderDataMod,
  activeData,
  id,
}) => {
  Font.register({ family: "Montserrat-Regular", src: MontserratRegular });
  Font.register({ family: "Montserrat-ExtraBold", src: MontserratExtraBold });
  Font.registerHyphenationCallback((word) => {
    return [word];
  });
  const styles = StyleSheet.create({
    page: { backgroundColor: "tomato", marginBottom: 30 },
    container: {
      padding: 20,
      paddingTop: 0,
    },
    header: {
      height: "auto",
    },
    table: {
      display: "table",
      width: "100%",
      marginTop: 20,
    },
    row: {
      flexDirection: "row",
      alignItems: "center",
    },
    headerRow: {
      height: 130,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },

    cell: {
      textAlign: "left",
      fontWeight: "medium",
      fontSize: 11,
      minHeight: 25,
      color: "black",
      paddingTop: 5,
      paddingBottom: 5,
    },
    headerCell: {
      display: "flex",
      flexDirection: "row",
      backgroundColor: "#f2f4f8",
      color: "#0146d5",
      fontWeight: "extrabold",
      fontSize: 11,
      height: 30,
      textAlign: "left",
      alignItems: "center",
    },
  });

  let removeFirstTendata = _.cloneDeep(activeData?.items)?.slice(0, 14) || [];
  let newData =
    _.chunk(
      _.cloneDeep(activeData?.items)?.slice(14, activeData?.items?.length),
      34
    ) || [];
  let finaldata = [[...removeFirstTendata], ...newData];

  /** Variable declarations ----------------------------------------------------- **/
  const projectManager =
    getIndividualDispatchOrderDataMod?.projectManager || {};
  const depotManager = getIndividualDispatchOrderDataMod?.depotManager || {};
  const deliveryAddress = getIndividualDispatchOrderDataMod?.address || {};
  const raisedBy = getIndividualDispatchOrderDataMod?.raisedBy || {};
  const approvedBy = getIndividualDispatchOrderDataMod?.approvedBy || {};
  let damageCountForDispatch =
    _.filter(activeData?.items || [], (d) => d.condition === "Damaged")
      ?.length || 0;
  let unitsCountForDispatch = _.sumBy(
    activeData?.items,
    (d) => d?.quantityDispatched
  );
  let internalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(activeData?.items || [], (d) => d.storageId === 21) || [],
      (d1) => parseFloat(d1.spaceReleased)
    )
  );
  let externalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(activeData?.items || [], (d) => d.storageId === 22) || [],
      (d1) => parseFloat(d1.spaceReleased)
    )
  );
  return (
    <Document>
      <Page size="A4" wrap>
        <View fixed style={{ height: 20 }}></View>
        <View style={styles.container}>
          <View style={styles.header}>
            <View style={styles.headerRow}>
              <Image
                style={{ height: 105, width: 90, marginTop: 20 }}
                source={FORSlogo}
              />
              <Image
                style={{ height: 80, width: 150, marginTop: 20 }}
                source={muzPdfLogo}
              />
            </View>
            <View>
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: "bold",
                  color: "#0146d5",
                  fontFamily: "Montserrat-ExtraBold",
                }}
              >
                {getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? "DELIVERY ORDER" : "COLLECTION ORDER"}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                paddingTop: 4,
              }}
            >
              <View style={{ textAlign: "left" }}>
                <Text
                  style={{
                    fontSize: 13,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  MUZTRANS LTD.
                </Text>
                <Text

                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 11,
                    fontWeight: "500"
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Montserrat-Regular",
                      fontSize: 11,
                      fontWeight: "500",
                    }}
                  >
                    Bronze Age Way, Erith, Kent, DA8 1AX
                  </Text>
                  {"\n"}
                  Tel: 02083207602
                </Text>
              </View>
              {/* Add another view with the second content */}
              {/* Example: <View style={{ textAlign: 'left' }}>...</View> */}
            </View>
            <View
              style={{
                marginTop: 15,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flex: 0.23 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  ORDER NUMBER
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {getIndividualDispatchOrderDataMod?.orderNo || ""}
                </Text>
              </View>
              <View style={{ flex: 0.23 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  RAISED ON
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {
                    convertIsoToLocalDateTime(`${getIndividualDispatchOrderDataMod?.raisedBy?.raisedOn}.00Z`, "DD-MMM-YYYY HH:mm")
                  }
                </Text>
              </View>
              <View style={{ flex: 0.23 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  {/* DELIVERY DUE   */}
                  {getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? " DELIVERY DUE " : "COLLECTION DUE"}
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {convertIsoToLocalDateTime(`${getIndividualDispatchOrderDataMod?.dueDate?.split("T")[0]}T${getIndividualDispatchOrderDataMod?.dueTime ? getIndividualDispatchOrderDataMod?.dueTime : "00:00:00"}.00Z`, "DD-MMM-YYYY HH:mm")}
                </Text>
              </View>
              <View style={{ flex: 0.23 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  DELIVERY ADDRESS
                </Text>

                <Text
                  wrap={false}
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                    whiteSpace: "nowrap",
                    wordBreak: "break-word",
                  }}
                >
                  {deliveryAddress?.street1 && deliveryAddress?.street1 + ", "}
                  {deliveryAddress?.city && deliveryAddress?.city + ", "}
                  {deliveryAddress?.state && deliveryAddress?.state + ", "}
                  {deliveryAddress?.country && deliveryAddress?.country + ", "}
                  {deliveryAddress?.zip && deliveryAddress?.zip}
                </Text>
              </View>
            </View>
            <View
              style={{
                borderTopWidth: 2,
                borderTopColor: "gray",
                borderTopStyle: "solid",
                height: 0.5,
                marginTop: 5,
              }}
            />
            <View
              style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  CLIENT DETAIL
                </Text>
                <Text>
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 5,
                      lineHeight: 1.2,
                      fontFamily: "Montserrat-Regular",
                    }}
                  >
                    {getIndividualDispatchOrderDataMod?.clientName}
                    {", "}
                  </Text>
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 5,
                      lineHeight: 1.2,
                      fontFamily: "Montserrat-Regular",
                    }}
                  >
                    {getIndividualDispatchOrderDataMod?.clientAddress
                      ?.street1 &&
                      getIndividualDispatchOrderDataMod?.clientAddress
                        ?.street1 + ", "}
                    {getIndividualDispatchOrderDataMod?.clientAddress?.city &&
                      getIndividualDispatchOrderDataMod?.clientAddress?.city +
                      ", "}
                    {getIndividualDispatchOrderDataMod?.clientAddress?.state &&
                      getIndividualDispatchOrderDataMod?.clientAddress?.state +
                      ", "}
                    {getIndividualDispatchOrderDataMod?.clientAddress
                      ?.country &&
                      getIndividualDispatchOrderDataMod?.clientAddress
                        ?.country + ", "}
                    {getIndividualDispatchOrderDataMod?.clientAddress?.zip &&
                      getIndividualDispatchOrderDataMod?.clientAddress?.zip}
                  </Text>
                </Text>
              </View>

              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  PROJECT
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {getIndividualDispatchOrderDataMod?.projectName}
                </Text>
              </View>

              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 2,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  PROJECT MANAGER
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {projectManager?.firstName} {projectManager?.lastName}
                </Text>

                {chunkSubstr(projectManager?.email || "", 16).map((d) => {
                  return <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 2,
                      fontFamily: "Montserrat-Regular",
                    }}
                  >
                    {d}
                  </Text>
                })}
                {/* <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {projectManager?.email}
                </Text> */}
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 5,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {projectManager?.phoneNumber}
                </Text>
              </View>
            </View>

            <View
              style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  CONTACT PERSON
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {getIndividualDispatchOrderDataMod?.contactName}
                </Text>
                {chunkSubstr(getIndividualDispatchOrderDataMod?.contactEmail || "", 16).map((d) => {
                  return <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 2,
                      fontFamily: "Montserrat-Regular",
                      wordWrap: "wrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {d}
                  </Text>
                })}
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {getIndividualDispatchOrderDataMod?.contactPhone || ""}
                </Text>
              </View>
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  RAISED BY
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {raisedBy?.firstName || ""} {raisedBy?.lastName || ""}
                </Text>
                {chunkSubstr(raisedBy?.email || "", 16).map((d) => {
                  return <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 2,
                      fontFamily: "Montserrat-Regular",
                      wordWrap: "wrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {d}
                  </Text>
                })}
                {/* <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {raisedBy?.email || ""}
                </Text> */}
                {/* Commented block */}
                {/* <Text
            style={{
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'Montserrat-Regular',
            }}
          >
            {raisedBy?.phoneNumber || ''}
          </Text> */}
              </View>
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  ACCEPTED BY
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {approvedBy?.firstName} {approvedBy?.lastName}
                </Text>
                {chunkSubstr(approvedBy?.email || "", 16).map((d) => {
                  return <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "500",
                      marginBottom: 2,
                      fontFamily: "Montserrat-Regular",
                      wordWrap: "wrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {d}
                  </Text>
                })}
                {/* <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {approvedBy?.email}
                </Text> */}
                {/* Commented block */}
                {/* <Text
            style={{
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'Montserrat-Regular',
            }}
          >
            {approvedBy?.phoneNumber}
          </Text> */}
              </View>
            </View>

            <View
              style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  MANAGER & DEPOT
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {depotManager?.firstName} {depotManager?.lastName} at{" "}
                  {getIndividualDispatchOrderDataMod?.depotCode}
                </Text>
              </View>
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  VRN
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {activeData?.vrn}
                </Text>
              </View>
              <View style={{ flex: 0.3 }}>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "800",
                    color: "#0146d5",
                    marginBottom: 5,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  DRIVER
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {activeData?.driverName}
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "500",
                    marginBottom: 2,
                    fontFamily: "Montserrat-Regular",
                  }}
                >
                  {activeData?.driverContact}
                </Text>
              </View>
            </View>
            <View
              style={{
                borderTopWidth: 2,
                borderTopColor: "gray",
                borderTopStyle: "solid",
                height: 0.5,
                marginTop: 5,
              }}
            />

            <View
              style={{
                borderTopWidth: 0.4,
                borderBottomWidth: 0.4,
                background: "#f2f3f4",
                display: "flex",
                alignItems: "center",
                flex: 1,
                paddingLeft: 5,
              }}
            ></View>

            {/* end of header */}
          </View>
          <View style={styles.table}>
            {/* Table Header */}
            <View
              wrap={false}
              style={[
                styles.row,
                {
                  width: "100%",
                },
              ]}
            >
              <View style={[styles.cell, styles.headerCell, { width: "20%" }]}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: "#0146d5",
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  ITEMS
                </Text>
              </View>
              <View style={[styles.cell, styles.headerCell, { width: "20%" }]}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: "#0146d5",
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  {" "}
                  CONDITION
                </Text>
              </View>
              <View style={[styles.cell, styles.headerCell, { width: "40%" }]}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: "#0146d5",
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  {" "}
                  DESCRIPTION
                </Text>
              </View>
              <View style={[styles.cell, styles.headerCell, { width: "20%" }]}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: "#0146d5",
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  {" "}
                  UNIT
                </Text>
              </View>
              {/* Add more header cells as needed */}
            </View>

            {/* Table Rows */}
            {finaldata.map((nestedData, index) => {
              return [...nestedData].map((item, nIndex) => {
                return (
                  <View
                    wrap={false}
                    style={[
                      styles.row,
                      {
                        width: "100%",
                        backgroundColor: nIndex % 2 == 0 ? "white" : "#f2f4f8",
                      },
                    ]}
                  >
                    <View wrap={false} style={{ ...styles.cell, width: "20%" }}>
                      <Text
                        style={{
                          fontWeight: "medium",
                          fontSize: 10,
                          fontFamily: "Montserrat-Regular",
                          minHeight: 20,
                        }}
                      >
                        {" "}
                        {item?.itemNumber || ""}
                      </Text>
                    </View>
                    <View wrap={false} style={{ ...styles.cell, width: "20%" }}>
                      <Text
                        style={{
                          fontWeight: "medium",
                          fontSize: 10,
                          fontFamily: "Montserrat-Regular",
                          minHeight: 20,
                        }}
                      >
                        {item?.condition || ""}
                      </Text>
                    </View>
                    <View wrap={false} style={{ ...styles.cell, width: "40%" }}>
                      <Text
                        style={{
                          fontWeight: "medium",
                          fontSize: 10,
                          fontFamily: "Montserrat-Regular",
                          minHeight: 20,
                        }}
                      >
                        {" "}
                        {item?.description || ""}
                      </Text>
                    </View>
                    <View wrap={false} style={{ ...styles.cell, width: "20%" }}>
                      <Text
                        style={{
                          fontWeight: "medium",
                          fontSize: 10,
                          fontFamily: "Montserrat-Regular",
                          minHeight: 20,
                          paddingLeft: 10,
                        }}
                      >
                        {" "}
                        {item?.quantityDispatched || "0"}
                      </Text>
                    </View>
                    {/* Add more cells with data */}
                  </View>
                );
              });
            })}

            {/* tabel footer */}
            <View
              wrap={false}
              style={[
                styles.row,
                {
                  width: "100%",
                  backgroundColor: "#0045d9",
                  alignItems: "center",
                  marginTop: 10,
                },
              ]}
            >
              <View
                wrap={false}
                style={{
                  ...styles.cell,
                  width: "20%",
                  color: "white",

                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 9 }}>
                  {" "}
                  {activeData?.items?.length}{" "}
                </Text>
              </View>
              <View
                wrap={false}
                style={{
                  ...styles.cell,
                  width: "20%",
                  color: "white",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 10 }}>
                  {" "}
                  {damageCountForDispatch}
                </Text>
              </View>
              <View
                wrap={false}
                style={{
                  ...styles.cell,
                  width: "40%",
                  color: "white",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text> {""}</Text>
              </View>
              <View
                wrap={false}
                style={{
                  ...styles.cell,
                  width: "20%",
                  color: "white",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text> {unitsCountForDispatch}</Text>
              </View>
              {/* Add more cells with data */}
            </View>

            {/* Add more rows as needed */}
          </View>

          {/* footer at bottom */}

          <View wrap={false} style={{ paddingTop: 10 }}>
            <View wrap={false}>
              <Text
                style={{
                  fontSize: 11,
                  fontWeight: "bold",
                  fontFamily: "Montserrat-ExtraBold",
                }}
              >
                RECEIVER’S DETAILS
              </Text>
            </View>
            <View style={{ marginTop: 10, width: "100%" }}>
              <View
                style={{
                  flexDirection: "row",
                  // borderBottomWidth: 1,
                  // borderColor: "black",
                  // width: "100%",
                  // justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "black",
                    flex: 1,
                    padding: 7,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  Sign:
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontWeight: "bold",
                    textTransform: "uppercase",

                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "black",
                    flex: 1,
                    padding: 7,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  Print:
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontFamily: "Montserrat-Regular",
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "black",
                    flex: 1,
                    padding: 7,
                    fontFamily: "Montserrat-ExtraBold",
                  }}
                >
                  Date:
                </Text>
              </View>
              <View>
                <View
                  style={{
                    flexDirection: "row",
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "black",
                    borderTopWidth: 0,
                    padding: 7,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      fontFamily: "Montserrat-ExtraBold",
                    }}
                  >
                    Received in good condition:
                  </Text>
                  <View style={{ marginLeft: 170 }}>
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <View
                        style={{
                          width: 10,
                          height: 10,
                          border: 1,
                          borderRadius: 1,
                          borderColor: "#000",
                          backgroundColor: false ? "#000" : "transparent",
                          fontFamily: "Montserrat-ExtraBold",
                        }}
                      />
                      <Text
                        style={{
                          marginLeft: 5,
                          fontSize: 12,
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          fontFamily: "Montserrat-ExtraBold",
                        }}
                      >
                        Yes
                      </Text>
                    </View>
                  </View>
                  <View style={{ marginLeft: 50 }}>
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <View
                        style={{
                          width: 10,
                          height: 10,
                          border: 1,
                          borderRadius: 1,
                          borderColor: "#000",
                          backgroundColor: false ? "#000" : "transparent",
                        }}
                      />
                      <Text
                        style={{
                          marginLeft: 5,
                          fontSize: 12,
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          fontFamily: "Montserrat-ExtraBold",
                        }}
                      >
                        No
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "column",
                    padding: 7,
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderColor: "black",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      fontFamily: "Montserrat-ExtraBold",
                    }}
                  >
                    COMMENTS:
                  </Text>
                  <View
                    style={{
                      height: 30,
                      width: "100%",
                      fontFamily: "Montserrat-ExtraBold",
                    }}
                  />
                </View>
              </View>
            </View>

            <View style={{ marginTop: 10 }}>
              <View className="mt-2">
                <View
                  style={{
                    marginTop: -8,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginTop: 5,
                  }}
                >
                  <Image
                    src={New_SigmaLogo}
                    style={{ width: 150, height: 100 }}
                  />
                </View>
                <Text
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    fontFamily: "Montserrat-ExtraBold",
                    marginTop: 5,
                  }}
                >
                  We trade under R.H.A. Conditions of Carriage 2020 & R.H.A.
                  Conditions of Storage 2021 (a copy can be supplied upon
                  request)
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* <View style={{ backgroundColor: "red", height: 100, width: 100 }}>
          <Text>This is footer</Text>
        </View> */}
      </Page>
    </Document>);
};
export default newPDFComponent;
